/* Get current breakpoint */
function getCurrentBreakpoint() {
	const width = window.innerWidth;

	if (width >= 1920) return '3xl';
    if (width >= 1536) return '2xl';
    if (width >= 1280) return 'xl';
    if (width >= 1024) return 'lg';
    if (width >= 768) return 'md';
    if (width >= 640) return 'sm';

    return 'xs';
}

/* Display current breakpoint */
export function displayCurrentBreakpoint() {
	const breakpointOverlay = document.querySelector('#breakpoint-overlay div');

	if (!breakpointOverlay) {
		return;
	}

	breakpointOverlay.textContent = `${getCurrentBreakpoint()}`;
}
